import { ENCRYPT_STORAGE, WebLeft, WebTop, WebWidth } from "../../config/config";
import { ENTRY_MODE } from "../../database/store-names";
import { F_Fammily, Font } from "../../util/config-fonts";
import { isMobile } from "react-device-detect";
import React from "react";
import "../../styles/css/common-back-btn.css";
import "../../styles/css/pg-product-list-filter-textbox-show.css";

export default class HeaderCommon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    var hs = document.getElementsByTagName("style");
    for (let i = 0; i < hs.length; i++) {
      let x = hs[i].innerText.trim();
      let y = x.includes(".transform-active-fillter-product");
      if (y === true) {
        hs[i].parentNode.removeChild(hs[i]);
        break;
      }
    }

    var style = document.createElement("style");
    style.type = "text/css";
    if (isMobile) {
      style.innerHTML =
        ".transform-active-fillter-product {height: 50px !important; width:100% !important;}";
    } else {
      style.innerHTML =
        ".transform-active-fillter-product { height: 50px !important;width:" +
        WebWidth +
        "px !important;}";
    }

    document.getElementsByTagName("head")[0].appendChild(style);

    let box = document.querySelectorAll(".box");
    if (box) {
      box[0].style.left = isMobile ? 0 : WebLeft;
      box[0].style.width = isMobile ? "0px" : "10px";
      box[0].style.height = isMobile ? "0px" : "50px";
    }
  }

  render() {
    const entryMode = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
    const pathname = window.location.pathname || "";
    const isQrHeader =
      entryMode === "QR" && pathname.startsWith("/product-list/");

    return (
      <>
        <div
          style={{
            position: "fixed",
            left: isMobile ? 0 : WebLeft,
            width: isMobile ? "100%" : WebWidth,
            top: isMobile ? 0 : WebTop,
            backgroundColor: "white",
            color:  "black",
            zIndex: 1500,
            height: 50,
            boxShadow: "0 2px 6px 0 rgba(0,0,0,0.2)",
          }}
          id="DivHeaderHome"
        >
          <div
            className="btnBack"
            // style={{
            //   backgroundColor: "white",
            //   height: 30,
            //   width: 30,
            //   position: "absolute",
            //   top: 8,
            //   left: 10,
            //   zIndex: 150,
            //   borderRadius: 100,
            //   elevation: 2,
            //   shadowColor: "#000",
            //   shadowOffset: { width: 0, height: 2 },
            //   shadowOpacity: 0.8,
            //   shadowRadius: 2,
            // }}
            id="HeaderNavigatorBackButton"
          >
            <div
              style={{
                paddingTop: "6px",
                paddingLeft: "10px",
                cursor: "pointer",
                alignItems: "center",
              }}
            >
              <i
                style={{
                  fontSize: Font.TopNavigationIcon,
                  color:  "black",
                }}
                className="bi bi-chevron-left"
              />
            </div>
          </div>

          <p
            style={{
              textAlign: isQrHeader ? "left" : "center",
              fontFamily: F_Fammily.Medium,
              color:  "black",
              fontSize: '20',
              fontWeight: 'bold',
              paddingLeft: isQrHeader ? 16 : 0,
              paddingRight: isQrHeader ? 16 : 0,
            }}
            id="HeaderTabName"
          />

          <div>
            <div
              style={{
                display: "none",
                backgroundColor:  "white",
                height: 30,
                width: 30,
                position: "absolute",
                top: 8,
                right: 10,
                zIndex: 150,
                borderRadius: 100,
                elevation: 2,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.8,
                shadowRadius: 2,
                padding: 5,
                cursor: "pointer",
                marginRight: "15px",
              }}
              id="HeaderNavigatorMenu"
            >
              <i
                id="HeaderNavigatorBoostrapIcon"
                style={{ fontSize: Font.TopNavigationIcon, color:"black" }}
                className="bi bi-search"
              />
            </div>

            <div
              className="box transform"
              style={{
                padding: 8,
                backgroundColor: "white",
              }}
            >
              <div style={{ display: "flex" }}>
                <input
                  className="productlistFilterTextBox"
                  type="text"
                  style={{
                    display: "none",
                    width: "90%",
                    height: 32,
                    border: "none",
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    paddingLeft: "8px",
                  }}
                  placeholder="Filter Items"
                  id="InputproductlistFilterTextBox"
                ></input>
                <button
                  className="productlistFilterTextBox"
                  style={{
                    display: "none",
                    height: 32,
                    border: "none",
                    cursor: "pointer",
                    borderRight: "1px solid gray",
                    color: "#a1a1a1",
                    backgroundColor: "#fff",
                    padding: "7px",
                  }}
                  id="btnproductlistFilterTextBoxclear"
                >
                  <i className="bi bi-x-circle-fill"/>
                </button>
                <button
                  className="productlistFilterTextBox"
                  style={{
                    display: "none",
                    height: 32,
                    border: "none",
                    cursor: "pointer",
                    borderTopRightRadius: 5,
                    borderBottomRightRadius: 5,
                    backgroundColor: "white",
                    fontFamily: F_Fammily.Medium,
                    fontWeight: "600",
                  }}
                  id="btnproductlistFilterTextBoxClsoe"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
